<style scoped lang="scss" type="text/scss">
    .add-block-container {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: .15rem;
        box-sizing: border-box;
        color: #999;
        transition: all .2s;
        .icon {
            font-size: 1.8rem;
        }
        .text {
            font-size: .9rem;
            margin-left: .75rem;
        }

        border: .1rem solid #FFF;
        &:hover {
            cursor: pointer;
            color: #427DFF;
            background-color: #FFF;
        }

        &.reversed {
            border-color: #EEE;
            &:hover {
                background-color: #EEE;
            }
        }

        &.small {
            .icon {
                font-size: 1.6rem;
            }
            .text {
                font-size: .85rem;
                margin-left: .75rem;
            }
        }
    }
</style>

<template>
    <div class="add-block-container" :class="{'reversed': true === reversed, 'small': size === 'small'}">
        <i class="icon">&#xe6bb;</i>
        <span class="text">添加{{ title }}</span>
    </div>
</template>

<script>
    export default {
        name: '',
        props: {
            title: {
                type: String,
                default: ''
            },
            reversed: {
                type: Boolean,
                default: false
            },
            size: {
                type: String,
                default: ''
            }
        },
        data () {
            return {};
        }
    };
</script>
